import { useMemo } from 'react';

export const usePollingInterval = (interval: number) =>
  useMemo(() => interval * 1000, [interval]);
